// translations.js
const translations = {
    orderDetails: 'פרטי הזמנה',
    productsInOrder: 'מוצרים בהזמנה',
    driverNotes: 'הערות לנהג',
    generalText: 'טקסט כללי',
    internalDialogtext: 'דו שיח פנימי',
    attachedFiles: 'קבצים מצורפים',
    noDriverNotes: 'אין הערות לנהג',
    noGeneralText: 'אין טקסט כללי',
    noInternalDialogtext: 'אין דו שיח פנימי',
    noAttachedFiles: 'לא מצורפים קבצים',
    downloadFileErr: 'הורדת הקובץ נכשלה',
    orderNumber: 'מספר הזמנה',
    status: 'סטטוס',
    orderDate: 'תאריך הזמנה',
    deliveryDate: 'תאריך אספקה',
    customerName: 'שם לקוח',
    address: 'כתובת',
    productQuantityOverLimit: 'כמות המוצר שהוזמנה חורגת מהמלאי הזמין',
    productRequiresApproval: 'מוצר זה דורש אישור',
    duplicateOrder: 'שכפל הזמנה'
  };
  
  export default translations;
  